import { Component } from '@angular/core';

import { PortalsBaseComponent } from '../portals-base/portals-base.component';

@Component({
  standalone: true,
  imports: [PortalsBaseComponent],
  selector: 'app-portals-external',
  template: `
    <app-portals-base
      [config]="{
        isExternal: true,
        domainSuffix: '.unthread.com',
        title: 'External Customer Portal',
        noPortalMessage: 'You don\\'t have an external portal',
        noPortalDescription:
          'Create an external portal to allow your employees to access & search knowledge bases and submit tickets.'
      }"
    ></app-portals-base>
  `,
})
export class PortalsExternalComponent {}
